export const FLOW_CARD_TEST_ID = 'flow-card'
export const FLOW_CARD_BUTTON_TEST_ID = 'flow-card-button'
export const FLOW_CARD_TITLE_TEST_ID = 'flow-card-title'
export const BUTTON_CLICK_EVENT_NAME = 'buttonClick'
